var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5349 1.46211C17.1679 5.06229 19.1713 9.47965 20.6741 11.2348C20.9693 10.5531 20.9371 9.40987 21.2726 6.61883C21.5758 4.10153 23.653 3.86134 24.5453 4.0398C26.5178 4.45175 27.1176 6.44976 27.0519 7.18643C26.9472 8.36055 26.9418 8.32029 26.7271 11.161C26.4118 15.314 28.0153 18.4499 28.1629 22.0058C28.1629 28.707 22.2897 31.9999 18.1796 31.9999C14.8908 31.9999 11.5993 29.8959 10.3661 28.8438L4.19908 23.2108C3.44497 22.6244 1.57847 20.6868 0.759953 19.5717C-1.47286 16.5351 1.75559 14.4431 3.56975 14.9691C3.42752 14.8591 2.56606 13.4609 2.15412 12.7766C1.04711 10.5531 2.15412 9.07307 2.97264 8.66515C4.8284 7.74196 6.19304 8.78055 6.62243 9.34681C6.45738 9.0677 5.94212 7.93787 5.11152 5.86471C4.28093 3.7929 5.61874 2.51278 6.39163 2.13169C8.06893 1.35476 9.66303 2.34102 10.0616 3.22262C10.2575 3.65335 11.3095 5.95998 11.7684 6.97576C11.4222 6.13308 10.7969 4.45712 10.5755 3.68287C10.1354 1.85796 11.1941 0.607355 11.8663 0.285312C12.7989 -0.161523 14.7459 -0.278264 15.5161 1.41783L15.5349 1.46211Z",
    fill: "url(#paint0_radial_768_6340)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5345 1.46211C17.1675 5.06229 19.1709 9.47965 20.6737 11.2348C20.9689 10.5531 20.9367 9.40987 21.2722 6.61883C21.5754 4.10153 23.6526 3.86134 24.5449 4.0398C26.5174 4.45175 27.1172 6.44976 27.0515 7.18643C26.9468 8.36055 26.9414 8.32029 26.7268 11.161C26.4114 15.314 28.0149 18.4499 28.1625 22.0058C28.1625 28.707 22.2893 31.9999 18.1793 31.9999C14.8904 31.9999 11.5989 29.8959 10.3658 28.8438L4.19869 23.2108C3.44323 22.6244 1.57808 20.6868 0.758222 19.5717C-1.47325 16.5351 1.7552 14.4431 3.56937 14.9691C3.42713 14.8591 2.56567 13.4609 2.15373 12.7766C1.04672 10.5531 2.15373 9.07307 2.97225 8.66515C4.82801 7.74196 6.19265 8.78055 6.62204 9.34681C6.45699 9.0677 5.94173 7.93787 5.11113 5.86471C4.28054 3.7929 5.61835 2.51278 6.39124 2.13169C8.06854 1.35476 9.66264 2.34102 10.0612 3.22262C10.2571 3.65335 11.3091 5.95998 11.768 6.97576C11.4218 6.13308 10.7965 4.45712 10.5751 3.68287C10.135 1.85796 11.1937 0.607355 11.8646 0.285312C12.7985 -0.161523 14.7455 -0.278264 15.5144 1.41783L15.5345 1.46211Z",
    fill: "url(#paint1_radial_768_6340)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0512 7.1857C26.9465 8.35982 26.9412 8.31957 26.7265 11.1603C26.6151 12.6282 27.4122 18.0319 27.4122 18.0319C25.4732 18.6652 21.2719 17.8266 20.6748 11.2341C20.9687 10.5524 20.9365 9.40914 21.2719 6.6181C21.5752 4.1008 23.6523 3.86061 24.5447 4.03907C26.5172 4.45102 27.117 6.44903 27.0512 7.1857Z",
    fill: "url(#paint2_radial_768_6340)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0512 7.1857C26.9465 8.35982 26.9412 8.31957 26.7265 11.1603C26.6151 12.6282 27.4122 18.0319 27.4122 18.0319C25.4732 18.6652 21.2719 17.8266 20.6748 11.2341C20.9687 10.5524 20.9365 9.40914 21.2719 6.6181C21.5752 4.1008 23.6523 3.86061 24.5447 4.03907C26.5172 4.45102 27.117 6.44903 27.0512 7.1857Z",
    fill: "url(#paint3_radial_768_6340)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0512 7.1857C26.9465 8.35982 26.9412 8.31957 26.7265 11.1603C26.6151 12.6282 27.4122 18.0319 27.4122 18.0319C25.4732 18.6652 21.2719 17.8266 20.6748 11.2341C20.9687 10.5524 20.9365 9.40914 21.2719 6.6181C21.5752 4.1008 23.6523 3.86061 24.5447 4.03907C26.5172 4.45102 27.117 6.44903 27.0512 7.1857Z",
    fill: "url(#paint4_radial_768_6340)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.535 1.46211C17.168 5.06229 19.1714 9.47965 20.6742 11.2348C20.4394 13.2422 18.6454 14.203 17.0996 13.8433C15.1499 13.2771 14.4092 11.8936 14.4092 11.8936C14.4092 11.8936 13.8993 11.1046 13.4028 10.2365C12.8285 9.23275 12.9332 9.25556 11.9711 7.4387C11.7819 7.08177 10.856 4.66108 10.5756 3.68287C10.1355 1.85796 11.1942 0.607355 11.8664 0.285312C12.799 -0.161523 14.746 -0.278264 15.5162 1.41783L15.535 1.46211Z",
    fill: "url(#paint5_radial_768_6340)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.535 1.46211C17.168 5.06229 19.1714 9.47965 20.6742 11.2348C20.4394 13.2422 18.6454 14.203 17.0996 13.8433C15.1499 13.2771 14.4092 11.8936 14.4092 11.8936C14.4092 11.8936 13.8993 11.1046 13.4028 10.2365C12.8285 9.23275 12.9332 9.25556 11.9711 7.4387C11.7819 7.08177 10.856 4.66108 10.5756 3.68287C10.1355 1.85796 11.1942 0.607355 11.8664 0.285312C12.799 -0.161523 14.746 -0.278264 15.5162 1.41783L15.535 1.46211Z",
    fill: "url(#paint6_linear_768_6340)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.535 1.46211C17.168 5.06229 19.1714 9.47965 20.6742 11.2348C20.4394 13.2422 18.6454 14.203 17.0996 13.8433C15.1499 13.2771 14.4092 11.8936 14.4092 11.8936C14.4092 11.8936 13.8993 11.1046 13.4028 10.2365C12.8285 9.23275 12.9332 9.25556 11.9711 7.4387C11.7819 7.08177 10.856 4.66108 10.5756 3.68287C10.1355 1.85796 11.1942 0.607355 11.8664 0.285312C12.799 -0.161523 14.746 -0.278264 15.5162 1.41783L15.535 1.46211Z",
    fill: "url(#paint7_radial_768_6340)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.535 1.46211C17.168 5.06229 19.1714 9.47965 20.6742 11.2348C20.4394 13.2422 18.6454 14.203 17.0996 13.8433C15.1499 13.2771 14.4092 11.8936 14.4092 11.8936C14.4092 11.8936 13.8993 11.1046 13.4028 10.2365C12.8285 9.23275 12.9332 9.25556 11.9711 7.4387C11.7819 7.08177 10.856 4.66108 10.5756 3.68287C10.1355 1.85796 11.1942 0.607355 11.8664 0.285312C12.799 -0.161523 14.746 -0.278264 15.5162 1.41783L15.535 1.46211Z",
    fill: "url(#paint8_radial_768_6340)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.535 1.46211C17.168 5.06229 19.1714 9.47965 20.6742 11.2348C20.4394 13.2422 18.6454 14.203 17.0996 13.8433C15.1499 13.2771 14.4092 11.8936 14.4092 11.8936C14.4092 11.8936 13.8993 11.1046 13.4028 10.2365C12.8285 9.23275 12.9332 9.25556 11.9711 7.4387C11.7819 7.08177 10.856 4.66108 10.5756 3.68287C10.1355 1.85796 11.1942 0.607355 11.8664 0.285312C12.799 -0.161523 14.746 -0.278264 15.5162 1.41783L15.535 1.46211Z",
    fill: "url(#paint9_linear_768_6340)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0614 3.2219C10.3244 3.80158 12.1386 7.77345 11.9709 7.43798C12.458 8.5383 13.9702 11.222 14.409 11.956C15.3805 13.5743 14.2842 14.9201 13.5771 15.3307C11.5415 16.5116 10.3728 15.006 10.3728 15.006C9.29928 13.4334 8.40294 12.1237 6.63037 9.33536C6.20367 8.53025 5.42541 6.73486 5.11142 5.864C4.33718 3.71436 5.61863 2.51206 6.39153 2.13098C8.06882 1.35405 9.66292 2.34031 10.0614 3.2219Z",
    fill: "url(#paint10_radial_768_6340)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0614 3.2219C10.3244 3.80158 12.1386 7.77345 11.9709 7.43798C12.458 8.5383 13.9702 11.222 14.409 11.956C15.3805 13.5743 14.2842 14.9201 13.5771 15.3307C11.5415 16.5116 10.3728 15.006 10.3728 15.006C9.29928 13.4334 8.40294 12.1237 6.63037 9.33536C6.20367 8.53025 5.42541 6.73486 5.11142 5.864C4.33718 3.71436 5.61863 2.51206 6.39153 2.13098C8.06882 1.35405 9.66292 2.34031 10.0614 3.2219Z",
    fill: "url(#paint11_linear_768_6340)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0614 3.2219C10.3244 3.80158 12.1386 7.77345 11.9709 7.43798C12.458 8.5383 13.9702 11.222 14.409 11.956C15.3805 13.5743 14.2842 14.9201 13.5771 15.3307C11.5415 16.5116 10.3728 15.006 10.3728 15.006C9.29928 13.4334 8.40294 12.1237 6.63037 9.33536C6.20367 8.53025 5.42541 6.73486 5.11142 5.864C4.33718 3.71436 5.61863 2.51206 6.39153 2.13098C8.06882 1.35405 9.66292 2.34031 10.0614 3.2219Z",
    fill: "url(#paint12_radial_768_6340)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0614 3.2219C10.3244 3.80158 12.1386 7.77345 11.9709 7.43798C12.458 8.5383 13.9702 11.222 14.409 11.956C15.3805 13.5743 14.2842 14.9201 13.5771 15.3307C11.5415 16.5116 10.3728 15.006 10.3728 15.006C9.29928 13.4334 8.40294 12.1237 6.63037 9.33536C6.20367 8.53025 5.42541 6.73486 5.11142 5.864C4.33718 3.71436 5.61863 2.51206 6.39153 2.13098C8.06882 1.35405 9.66292 2.34031 10.0614 3.2219Z",
    fill: "url(#paint13_radial_768_6340)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0614 3.2219C10.3244 3.80158 12.1386 7.77345 11.9709 7.43798C12.458 8.5383 13.9702 11.222 14.409 11.956C15.3805 13.5743 14.2842 14.9201 13.5771 15.3307C11.5415 16.5116 10.3728 15.006 10.3728 15.006C9.29928 13.4334 8.40294 12.1237 6.63037 9.33536C6.20367 8.53025 5.42541 6.73486 5.11142 5.864C4.33718 3.71436 5.61863 2.51206 6.39153 2.13098C8.06882 1.35405 9.66292 2.34031 10.0614 3.2219Z",
    fill: "url(#paint14_radial_768_6340)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0614 3.2219C10.3244 3.80158 12.1386 7.77345 11.9709 7.43798C12.458 8.5383 13.9702 11.222 14.409 11.956C15.3805 13.5743 14.2842 14.9201 13.5771 15.3307C11.5415 16.5116 10.3728 15.006 10.3728 15.006C9.29928 13.4334 8.40294 12.1237 6.63037 9.33536C6.20367 8.53025 5.42541 6.73486 5.11142 5.864C4.33718 3.71436 5.61863 2.51206 6.39153 2.13098C8.06882 1.35405 9.66292 2.34031 10.0614 3.2219Z",
    fill: "url(#paint15_linear_768_6340)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97261 8.66452C4.82836 7.74133 6.19301 8.77992 6.6224 9.34618C7.96289 11.3683 9.56102 13.6669 10.299 14.8907C12.2715 18.1514 8.23528 19.5657 8.23528 19.5657C4.52377 15.3831 3.83675 15.1725 3.56972 14.9672C3.42749 14.8585 2.56603 13.4603 2.15409 12.7759C1.04708 10.5525 2.15409 9.0711 2.97261 8.66452Z",
    fill: "url(#paint16_radial_768_6340)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97261 8.66452C4.82836 7.74133 6.19301 8.77992 6.6224 9.34618C7.96289 11.3683 9.56102 13.6669 10.299 14.8907C12.2715 18.1514 8.23528 19.5657 8.23528 19.5657C4.52377 15.3831 3.83675 15.1725 3.56972 14.9672C3.42749 14.8585 2.56603 13.4603 2.15409 12.7759C1.04708 10.5525 2.15409 9.0711 2.97261 8.66452Z",
    fill: "url(#paint17_linear_768_6340)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97261 8.66452C4.82836 7.74133 6.19301 8.77992 6.6224 9.34618C7.96289 11.3683 9.56102 13.6669 10.299 14.8907C12.2715 18.1514 8.23528 19.5657 8.23528 19.5657C4.52377 15.3831 3.83675 15.1725 3.56972 14.9672C3.42749 14.8585 2.56603 13.4603 2.15409 12.7759C1.04708 10.5525 2.15409 9.0711 2.97261 8.66452Z",
    fill: "url(#paint18_radial_768_6340)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97261 8.66452C4.82836 7.74133 6.19301 8.77992 6.6224 9.34618C7.96289 11.3683 9.56102 13.6669 10.299 14.8907C12.2715 18.1514 8.23528 19.5657 8.23528 19.5657C4.52377 15.3831 3.83675 15.1725 3.56972 14.9672C3.42749 14.8585 2.56603 13.4603 2.15409 12.7759C1.04708 10.5525 2.15409 9.0711 2.97261 8.66452Z",
    fill: "url(#paint19_radial_768_6340)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97261 8.66452C4.82836 7.74133 6.19301 8.77992 6.6224 9.34618C7.96289 11.3683 9.56102 13.6669 10.299 14.8907C12.2715 18.1514 8.23528 19.5657 8.23528 19.5657C4.52377 15.3831 3.83675 15.1725 3.56972 14.9672C3.42749 14.8585 2.56603 13.4603 2.15409 12.7759C1.04708 10.5525 2.15409 9.0711 2.97261 8.66452Z",
    fill: "url(#paint20_radial_768_6340)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97261 8.66452C4.82836 7.74133 6.19301 8.77992 6.6224 9.34618C7.96289 11.3683 9.56102 13.6669 10.299 14.8907C12.2715 18.1514 8.23528 19.5657 8.23528 19.5657C4.52377 15.3831 3.83675 15.1725 3.56972 14.9672C3.42749 14.8585 2.56603 13.4603 2.15409 12.7759C1.04708 10.5525 2.15409 9.0711 2.97261 8.66452Z",
    fill: "url(#paint21_radial_768_6340)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75871 19.5713C-1.47276 16.5347 1.75569 14.4427 3.56985 14.9687C4.42863 15.4988 5.75704 16.8285 6.32196 17.4284C9.92076 20.9373 9.32096 22.0202 8.31458 23.2117C7.33907 24.0195 6.07103 24.6676 4.19917 23.2117C3.44372 22.624 1.57857 20.6864 0.75871 19.5713Z",
    fill: "url(#paint22_radial_768_6340)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75871 19.5713C-1.47276 16.5347 1.75569 14.4427 3.56985 14.9687C4.42863 15.4988 5.75704 16.8285 6.32196 17.4284C9.92076 20.9373 9.32096 22.0202 8.31458 23.2117C7.33907 24.0195 6.07103 24.6676 4.19917 23.2117C3.44372 22.624 1.57857 20.6864 0.75871 19.5713Z",
    fill: "url(#paint23_radial_768_6340)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75871 19.5713C-1.47276 16.5347 1.75569 14.4427 3.56985 14.9687C4.42863 15.4988 5.75704 16.8285 6.32196 17.4284C9.92076 20.9373 9.32096 22.0202 8.31458 23.2117C7.33907 24.0195 6.07103 24.6676 4.19917 23.2117C3.44372 22.624 1.57857 20.6864 0.75871 19.5713Z",
    fill: "url(#paint24_radial_768_6340)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75871 19.5713C-1.47276 16.5347 1.75569 14.4427 3.56985 14.9687C4.42863 15.4988 5.75704 16.8285 6.32196 17.4284C9.92076 20.9373 9.32096 22.0202 8.31458 23.2117C7.33907 24.0195 6.07103 24.6676 4.19917 23.2117C3.44372 22.624 1.57857 20.6864 0.75871 19.5713Z",
    fill: "url(#paint25_radial_768_6340)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75871 19.5713C-1.47276 16.5347 1.75569 14.4427 3.56985 14.9687C4.42863 15.4988 5.75704 16.8285 6.32196 17.4284C9.92076 20.9373 9.32096 22.0202 8.31458 23.2117C7.33907 24.0195 6.07103 24.6676 4.19917 23.2117C3.44372 22.624 1.57857 20.6864 0.75871 19.5713Z",
    fill: "url(#paint26_linear_768_6340)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5345 1.46211C17.1675 5.06229 19.1709 9.47965 20.6737 11.2348C20.9689 10.5531 20.9367 9.40987 21.2722 6.61883C21.5754 4.10153 23.6526 3.86134 24.5449 4.0398C26.5174 4.45175 27.1172 6.44976 27.0515 7.18643C26.9468 8.36055 26.9414 8.32029 26.7268 11.161C26.4114 15.314 28.0149 18.4499 28.1625 22.0058C28.1625 28.707 22.2893 31.9999 18.1793 31.9999C14.8904 31.9999 11.5989 29.8959 10.3658 28.8438L4.19869 23.2108C3.44323 22.6244 1.57808 20.6868 0.758222 19.5717C-1.47325 16.5351 1.7552 14.4431 3.56937 14.9691C3.42713 14.8591 2.56567 13.4609 2.15373 12.7766C1.04672 10.5531 2.15373 9.07307 2.97225 8.66515C4.82801 7.74196 6.19265 8.78055 6.62204 9.34681C6.45699 9.0677 5.94173 7.93787 5.11113 5.86471C4.28054 3.7929 5.61835 2.51278 6.39124 2.13169C8.06854 1.35476 9.66264 2.34102 10.0612 3.22262C10.2571 3.65335 11.3091 5.95998 11.768 6.97576C11.4218 6.13308 10.7965 4.45712 10.5751 3.68287C10.135 1.85796 11.1937 0.607355 11.8646 0.285312C12.7985 -0.161523 14.7455 -0.278264 15.5144 1.41783L15.5345 1.46211Z",
    fill: "url(#paint27_radial_768_6340)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5345 1.46211C17.1675 5.06229 19.1709 9.47965 20.6737 11.2348C20.9689 10.5531 20.9367 9.40987 21.2722 6.61883C21.5754 4.10153 23.6526 3.86134 24.5449 4.0398C26.5174 4.45175 27.1172 6.44976 27.0515 7.18643C26.9468 8.36055 26.9414 8.32029 26.7268 11.161C26.4114 15.314 28.0149 18.4499 28.1625 22.0058C28.1625 28.707 22.2893 31.9999 18.1793 31.9999C14.8904 31.9999 11.5989 29.8959 10.3658 28.8438L4.19869 23.2108C3.44323 22.6244 1.57808 20.6868 0.758222 19.5717C-1.47325 16.5351 1.7552 14.4431 3.56937 14.9691C3.42713 14.8591 2.56567 13.4609 2.15373 12.7766C1.04672 10.5531 2.15373 9.07307 2.97225 8.66515C4.82801 7.74196 6.19265 8.78055 6.62204 9.34681C6.45699 9.0677 5.94173 7.93787 5.11113 5.86471C4.28054 3.7929 5.61835 2.51278 6.39124 2.13169C8.06854 1.35476 9.66264 2.34102 10.0612 3.22262C10.2571 3.65335 11.3091 5.95998 11.768 6.97576C11.4218 6.13308 10.7965 4.45712 10.5751 3.68287C10.135 1.85796 11.1937 0.607355 11.8646 0.285312C12.7985 -0.161523 14.7455 -0.278264 15.5144 1.41783L15.5345 1.46211Z",
    fill: "url(#paint28_radial_768_6340)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5345 1.46211C17.1675 5.06229 19.1709 9.47965 20.6737 11.2348C20.9689 10.5531 20.9367 9.40987 21.2722 6.61883C21.5754 4.10153 23.6526 3.86134 24.5449 4.0398C26.5174 4.45175 27.1172 6.44976 27.0515 7.18643C26.9468 8.36055 26.9414 8.32029 26.7268 11.161C26.4114 15.314 28.0149 18.4499 28.1625 22.0058C28.1625 28.707 22.2893 31.9999 18.1793 31.9999C14.8904 31.9999 11.5989 29.8959 10.3658 28.8438L4.19869 23.2108C3.44323 22.6244 1.57808 20.6868 0.758222 19.5717C-1.47325 16.5351 1.7552 14.4431 3.56937 14.9691C3.42713 14.8591 2.56567 13.4609 2.15373 12.7766C1.04672 10.5531 2.15373 9.07307 2.97225 8.66515C4.82801 7.74196 6.19265 8.78055 6.62204 9.34681C6.45699 9.0677 5.94173 7.93787 5.11113 5.86471C4.28054 3.7929 5.61835 2.51278 6.39124 2.13169C8.06854 1.35476 9.66264 2.34102 10.0612 3.22262C10.2571 3.65335 11.3091 5.95998 11.768 6.97576C11.4218 6.13308 10.7965 4.45712 10.5751 3.68287C10.135 1.85796 11.1937 0.607355 11.8646 0.285312C12.7985 -0.161523 14.7455 -0.278264 15.5144 1.41783L15.5345 1.46211Z",
    fill: "url(#paint29_radial_768_6340)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8097 6.28027C18.8174 8.33867 19.8238 10.1837 20.6745 11.1941C20.7618 12.0932 20.8396 12.6057 21.0543 13.3813C19.3569 11.6826 17.7131 7.96966 17.8097 6.28027Z",
    fill: "url(#paint30_radial_768_6340)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_768_6340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4611 11.3271C15.862 12.3751 9.98072 15.8183 8.25244 23.4897",
    stroke: "#FFC339",
    strokeWidth: 2.68368,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_768_6340",
    x: 4.22647,
    y: 7.30167,
    width: 18.2604,
    height: 20.214,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.34184,
    result: "effect1_foregroundBlur_768_6340"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_768_6340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(14.0812 24.4887 -15.998 9.19914 14.0817 10.5303)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#FFC133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#FFC53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#FFAD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945,
    stopColor: "#EC7D58"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_768_6340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.1625 16.7364) rotate(-93.012) scale(16.7598 6.42056)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#FFE849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE647",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_768_6340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.50951 8.84781 -3.38954 -0.578294 26.1497 4.74237)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#FFE849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE647",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_768_6340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.6735 10.1472) scale(3.63029 14.7223)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE9F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE9F2C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_768_6340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-0.435345 -6.09486 4.23331 -0.302385 22.2676 15.8554)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC93D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC33A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_768_6340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-5.61893 3.11157 -6.25048 -11.2874 18.8547 6.57992)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#F09D2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09D2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_768_6340",
    x1: 15.5739,
    y1: 13.1603,
    x2: 15.5739,
    y2: 9.69166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC337",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_768_6340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.19323 -1.00639 2.22546 9.27288 17.5129 1.47285)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEC4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEC4C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_768_6340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.51844 2.31176 -1.79232 2.7279 10.4723 -0.000501455)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99F2B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_768_6340",
    x1: 11.1392,
    y1: 8.47595,
    x2: 13.2351,
    y2: 7.46958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A85300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#A85300",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_768_6340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-5.3153 3.17513 -6.62581 -11.0921 12.8015 8.56379)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#F09D2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09D2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_768_6340",
    x1: 9.69781,
    y1: 15.2797,
    x2: 9.69781,
    y2: 11.7399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC337",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_768_6340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.41072 -2.29131 6.97585 10.384 12.0876 4.61742)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEC4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEC4C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_768_6340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.69642 -2.1805 9.95635 21.4446 8.95846 9.69095)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#F09D2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09D2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_768_6340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.60618 2.30633 -1.83815 2.87421 4.26203 1.84919)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99F2B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_768_6340",
    x1: 6.14865,
    y1: 10.5296,
    x2: 7.54417,
    y2: 9.55409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A85300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#A85300",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_768_6340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.77266 3.47513 -6.80493 -7.38767 9.20811 13.9313)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#F09D2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09D2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_768_6340",
    x1: 6.26547,
    y1: 19.5657,
    x2: 6.26547,
    y2: 16.5962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC337",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_768_6340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.81693 -0.831945 1.76229 8.08538 7.95081 9.53001)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEC4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEC4C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_768_6340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.14934 -3.50861 17.937 21.213 5.56503 14.8773)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#F09D2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09D2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_768_6340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.42018 1.93533 -1.45656 2.57415 1.11014 8.29685)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99F2B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_768_6340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.5515 -1.59344 7.19451 7.00525 3.1712 16.0232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A85300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#A85300",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_768_6340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.0467 3.00877 -5.66112 -7.61415 8.06768 19.7658)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#F09D2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09D2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_768_6340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.09421 -0.720277 1.25129 7.1127 6.7178 15.9537)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEC4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEC4C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_768_6340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.45075 -3.03772 14.6657 21.4881 4.15789 20.5842)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#F09D2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09D2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_768_6340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.66862 1.6756 -1.11188 2.43443 -0.620696 14.8882)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99F2B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_768_6340",
    x1: 8.28774,
    y1: 28.9803,
    x2: 4.91029,
    y2: 22.0725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC337",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_768_6340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-14.6764 18.1149 -29.2955 -23.7351 20.3638 8.76981)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#F6814F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7814F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_768_6340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.87053 24.0693 -26.4091 6.44132 15.4996 9.02074)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.853,
    stopColor: "#F6814F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7814F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_768_6340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.84502 3.85781 -3.43915 1.64484 21.1179 2.7315)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99F2B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_768_6340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.39956 0.832526 -2.57613 -4.33081 21.0555 10.9065)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#B4813D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4813D",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.ade8c05f4007b3fa44918cd59b1ca56c.svg";
export { ForwardRef as ReactComponent };